import { humanizeEnumValue } from "common";
import { TFunction } from "i18next";

/**
 * Translated service-type label, falling back to a humanised enum
 * ("Power Monitor Service") so a new backend enum member never renders as
 * a dotted key path.
 */
export const serviceTypeLabel = (
  t: TFunction,
  serviceType?: string | null,
): string => {
  if (!serviceType) return "";
  // The installed i18next typings widen t()'s return to string | object
  // (returnObjects). This key is always a leaf string, so coerce here rather
  // than widen every caller.
  return String(
    t(`serviceRequests.serviceTypes.${serviceType}`, humanizeEnumValue(serviceType)),
  );
};
